import { WarehouseAddressTabProps } from "./types";
import { memo, useCallback, useState } from "react";
import { Button } from "ui/components/Button/Button";
import { AddressEditModal } from "ui/components/Map/AddressEditModal";
import { AddressEditFormValues } from "ui/components/Map/AddressEditModal/types";

const WarehouseAddressTab: React.FC<WarehouseAddressTabProps> = (props) => {
  const { formValues, setFormValues } = props;

  const [showAddressModal, setShowAddressModal] = useState(false);

  const addressFormValues: AddressEditFormValues = {
    country: formValues.addressCountry,
    state: formValues.addressState,
    city: formValues.addressCity,
    postalCode: formValues.addressPostalCode,
    line1: formValues.addressLine1,
    line2: formValues.addressLine2,
    latitude: formValues.addressLatitude,
    longitude: formValues.addressLongitude,
  };

  const handleAddressChange = useCallback((values: AddressEditFormValues) => {
    setFormValues((prev) => ({
      ...prev,
      addressCountry: values.country,
      addressState: values.state,
      addressCity: values.city,
      addressPostalCode: values.postalCode,
      addressLine1: values.line1,
      addressLine2: values.line2,
      addressLatitude: values.latitude ?? null,
      addressLongitude: values.longitude ?? null,
    }));
  }, [setFormValues]);

  const handleSave = useCallback(() => {
    setShowAddressModal(false);
  }, []);

  const hasAddress = formValues.addressLine1 || formValues.addressCity;

  return (
    <>
      <div className="border border-slate-300 rounded-sm px-4 pt-4 pb-4 -mt-[1px]">
        {hasAddress ? (
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-900">{formValues.addressLine1}</p>
              <p className="text-sm text-slate-500">
                {[formValues.addressPostalCode, formValues.addressCity, formValues.addressState, formValues.addressCountry]
                  .filter(Boolean)
                  .join(", ")}
              </p>
            </div>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setShowAddressModal(true)}
              startIcon="/media/icons/plus.svg"
            >
              Uredi adresu
            </Button>
          </div>
        ) : (

          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-900">Lokacija skladišta nije postavljena</p>
              <p className="text-sm text-slate-500">
                Označite lokaciju na karti ili unesite adresu ručno klikom na gumb "Dodaj adresu"
              </p>
            </div>
            <Button
              variant="primary"
              size="small"
              onClick={() => setShowAddressModal(true)}
              startIcon="/media/icons/plus.svg"
            >
              Dodaj adresu
            </Button>
          </div>
        )}
      </div>

      <AddressEditModal
        show={showAddressModal}
        title={hasAddress ? "Uredi adresu skladišta" : "Dodaj adresu skladišta"}
        formValues={addressFormValues}
        onChange={handleAddressChange}
        onSave={handleSave}
        onClose={() => setShowAddressModal(false)}
      />
    </>
  );
};
export default memo(WarehouseAddressTab);
